import React, {Component, createRef} from 'react';
import {connect} from "react-redux";
import './Campaign.css';
import Loading from "../Shared/Loading";
import {get, objectToFormData} from '../../utils/api'
import {withRouter} from 'react-router-dom';
import SVG from 'react-inlinesvg';
import closeicon from '../../assets/close.svg';
import {push} from "connected-react-router";
import UnitModal from "./UnitModal";
import CampaignModal from "./Campaign";
import {getCreativeInfo} from "../../actions/campaignActions";

class campaignModalContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            steps: 1,
            fullUserFlow: false,
            inputOptions: {
                brand: [],
                name: [],
                sellers: [],
                subcategory: [],
                verticals: [],
                designers: [],
                functionalities: [],
                creative_types: [],
                demo_types: [],
                thumbnail_device_types: []
            },
            showModal: {
                modal: false,
                unit: false
            },
            campaignInputValues: {},
            unitInputValues: {},
            modal: false,
            style: true
        };
    }

    closeModal(e) {
        if (e.keyCode === 27) {
            this.props.toggleModal('campaign', false);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.closeModal);
    }
    changeStep = (step) => {
        if(step == 2 && this.props.modal.unit !== undefined && this.props.modal.unit === true){
           step = 1
        }
        this.setState({
            steps: step,
        })
    }
    componentDidMount(){
        if(this.props.fullUserFlow){
            this.setState({fullUserFlow: true})
        }
    }
    getCampaignValues = (values, step, type) => {
        let campaignInputValues = "";
        if(type === 'unit'){
            this.setState({
                steps: step,
            })
        }
        if(type === 'campaign'){
            campaignInputValues = {
                brand_id: values.brand.id,
                brand_value: values.brand.value,
                hide_brand: values.hide_brand,
                name: values.name.value,
                id: values.name.id,
                seller_id: values.seller.id,
                seller_value: values.seller.value,
                subcategory: values.subcategory,
                verticals: values.verticals
            }
            this.setState({
                steps: step,
                campaignInputValues: campaignInputValues,
            })
        }
    }
    displayInfo = () => {
        if(this.props.fullUserFlow){
            // this is from the creative header add campaign button.
            if(this.state.steps === 1){
                return(
                    <CampaignModal
                        create={true}
                        toggleModal={this.props.toggleModal}
                        getCampaignValues={this.getCampaignValues}
                        brand={this.props.stages === "brandPage" ? this.props.brand : undefined}
                        flow={this.props.fullUserFlow}
                        prevCampaign={this.state.campaignInputValues}
                        getBannerInfo={this.props.getBanner}
                        changeSteps={this.changeStep}
                        inputOptions={this.props.inputOptions}
                    />
                )
            }else{
                return(
                    <UnitModal
                        toggleModal={this.props.toggleModal}
                        step={1}
                        inputOptions={this.props.inputOptions}
                        modal={this.state.showModal}
                        create={true}
                        flow={this.state.fullUserFlow}
                        changeSteps={this.changeStep}
                        campaign={this.state.campaignInputValues}
                        getCampaignValues={this.getCampaignValues}
                        // cid={this.props.campaign.campaign.id}
                        user={this.props.user}
                        loading={this.props.unit_loading}
                    />
                )
            }
        }else{
            if(this.props.modal.campaign){
                  return (
                      <CampaignModal
                          create={this.props.stages === "brandPage" ? true : false}
                          toggleModal={this.props.toggleModal}
                          getCampaignValues={this.getCampaignValues}
                          prevCampaign={this.state.campaignInputValues}
                          // brand={this.props.stages === "brandPage" ? this.}
                          campaign={this.props.campaign}
                          flow={this.props.fullUserFlow}
                          getBannerInfo={this.props.getBanner}
                          changeSteps={this.changeStep}
                          inputOptions={this.props.inputOptions}
                      />
                  )
            }
            if(this.props.stages === "unitPage"){
                return(
                    <UnitModal
                        toggleModal={this.props.toggleModal}
                        step={2}
                        inputOptions={this.props.inputOptions}
                        unitModal={false}
                        create={false}
                        flow={this.state.fullUserFlow}
                        changeSteps={this.changeStep}
                        campaign={this.props.campaign}
                        getCampaignValues={this.getCampaignValues}
                        // cid={this.props.campaign.campaign.id}
                        unit={this.props.unit}
                        user={this.props.user}
                        loading={this.props.unit_loading}
                    />
                )
            }else{
                return(
                    <UnitModal
                        toggleModal={this.props.toggleModal}
                        step={1}
                        inputOptions={this.props.inputOptions}
                        unitModal={false}
                        create={true}
                        flow={this.state.fullUserFlow}
                        changeSteps={this.changeStep}
                        campaign={this.props.campaign.campaign}
                        getCampaignValues={this.getCampaignValues}
                        user={this.props.user}
                        // cid={this.props.campaign.campaign.id}
                        loading={this.props.unit_loading}
                    />
                )
            }
        }
    }
    addStyle = () => {
        let styleName = true;
        if(this.props.modal.unit && this.state.steps === 1 || this.props.modal.unit && this.state.steps === 3 || this.props.fullUserFlow && this.state.steps === 2 ){
            if(this.props.stages === "unitPage"){
                styleName = false;
            }
        }else{
            if(this.props.stages === "campaignPage" && this.state.steps === 2){
                styleName = false;
            }
        }
        if(this.props.modal.campaign){
            if(this.state.steps !== 2){
                styleName = false;
            }
        }
        return styleName
    }
    render() {
        let type = this.props.modal.campaign ? 'campaign': this.props.modal.unit ? 'unit': '';
        return (
            <div className="modal-overlay">
            <section className={`modal ${this.props.modal.unit || this.state.steps === 2 || this.state.steps === 3 ? 'modal--unit' : 'modal--campaign'}`} >
                <div className="modal-content" style={this.addStyle() ? { maxWidth: "469px" } : {}} >
                    <div className="closeBtn" onClick={() => this.props.toggleModal(type,false)}>
                        <SVG src={closeicon}/>
                    </div>
                    {this.displayInfo()}
                     <div className="steps-container">Step {this.props.stages === "unitPage" ? 2 : this.state.steps} of {this.props.stages === "campaignPage" || this.props.stages === "unitPage"  ? 2 : 3}</div>
                </div>
            </section>
            </div>
        );
    }

}

const mapStateToProps = state => ({
    loading: state.campaign.loading,
    unit_loading: state.unit.loading
});

export default withRouter(connect(mapStateToProps)(campaignModalContainer));
